/* AMTENDENCY — contador e setas do carrossel da galeria no celular.

   A referência não usa bolinhas: são um contador de 45x35 ("atual / total") e
   duas setas de 35x35, os três SOBRE a foto, encostados no canto inferior
   direito (medido a 390px: contador em x259, setas em x306 e x343, todos com
   `bottom: 2px`). Eles flutuam por cima da imagem — não empurram nada. A
   navegação continua sendo o scroll nativo do slider do Dawn, então o swipe
   segue funcionando igual.

   Uma seta desabilita quando não há para onde ir; com uma foto só, nem aparece. */
(function () {
  var SETA =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path>' +
    '</svg>';

  function monta(lista) {
    if (lista.dataset.amSetas === '1') return;
    var slides = Array.prototype.slice.call(lista.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;
    lista.dataset.amSetas = '1';

    var caixa = document.createElement('div');
    caixa.className = 'am-galeria-setas';

    function botao(dir, rotulo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'am-galeria-seta am-galeria-seta--' + dir;
      b.setAttribute('aria-label', rotulo);
      b.innerHTML = SETA;
      b.addEventListener('click', function () {
        // dá a volta, como o carrossel deles: da primeira foto o "anterior"
        // leva à última e vice-versa (medido: as setas nunca desabilitam,
        // ficam sempre em `opacity: 1`)
        var i = atual();
        var n = slides.length;
        var alvo = slides[(((dir === 'ant' ? i - 1 : i + 1) % n) + n) % n];
        if (alvo) alvo.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      return b;
    }

    // contador "atual / total", à esquerda das setas, como na referência
    var conta = document.createElement('div');
    conta.className = 'am-galeria-conta';
    var deQual = document.createElement('span');
    var total = document.createElement('span');
    total.textContent = String(slides.length);
    conta.appendChild(deQual);
    conta.appendChild(document.createTextNode('/'));
    conta.appendChild(total);

    var ant = botao('ant', 'Foto anterior');
    var prox = botao('prox', 'Próxima foto');
    caixa.appendChild(conta);
    caixa.appendChild(ant);
    caixa.appendChild(prox);
    lista.parentNode.insertBefore(caixa, lista.nextSibling);

    function atual() {
      var centro = lista.scrollLeft + lista.clientWidth / 2;
      var idx = 0;
      var min = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - centro);
        if (d < min) {
          min = d;
          idx = i;
        }
      });
      return idx;
    }

    var agendado = false;
    function pinta() {
      agendado = false;
      deQual.textContent = String(atual() + 1);
    }
    lista.addEventListener(
      'scroll',
      function () {
        if (agendado) return;
        agendado = true;
        requestAnimationFrame(pinta);
      },
      { passive: true }
    );
    pinta();
  }

  /* ---- Contador do visualizador de foto (o product-modal do Dawn,
     re-vestido pelo CSS como swipe horizontal no celular). Mesma régua do
     contador do carrossel: "n / total" no rodapé direito. O índice sai da
     rolagem: cada foto ocupa exatamente uma janela. ---- */
  function montaVisor() {
    var modal = document.querySelector('product-modal.product-media-modal:not(.am-media-viewer)');
    if (!modal || modal.dataset.amVisor === '1') return;
    var corpo = modal.querySelector('.product-media-modal__content');
    var dialogo = modal.querySelector('.product-media-modal__dialog');
    if (!corpo || !dialogo) return;
    modal.dataset.amVisor = '1';

    var conta = document.createElement('div');
    conta.className = 'am-galeria-conta';
    var deQual = document.createElement('span');
    var total = document.createElement('span');
    conta.appendChild(deQual);
    conta.appendChild(document.createTextNode('/'));
    conta.appendChild(total);
    dialogo.appendChild(conta);

    function pinta() {
      var n = [].filter.call(corpo.children, function (c) {
        return c.clientWidth > 0;
      }).length;
      total.textContent = String(n);
      var i = corpo.clientWidth ? Math.round(corpo.scrollLeft / corpo.clientWidth) : 0;
      deQual.textContent = String(Math.min(n, i + 1));
    }

    var agendado = false;
    corpo.addEventListener(
      'scroll',
      function () {
        if (agendado) return;
        agendado = true;
        requestAnimationFrame(function () {
          agendado = false;
          pinta();
        });
      },
      { passive: true }
    );
    // ao abrir, o Dawn rola até a foto tocada; o contador pinta em seguida.
    // E as fotos deixam de ser preguiçosas: num scroller horizontal o lazy
    // do navegador só busca a foto quando ela já está entrando na tela — um
    // swipe rápido mostrava tela branca até a rede responder.
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) return;
      modal.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
      requestAnimationFrame(pinta);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    pinta();
  }

  function inicia() {
    document.querySelectorAll('media-gallery .product__media-list.slider--mobile').forEach(monta);
    montaVisor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
  // a troca de variante re-renderiza a galeria
  document.addEventListener('shopify:section:load', inicia);
})();
